import React from 'react';
var Menu = require('../ui_elements/menu').Menu;
var MenuList = require('../ui_elements/menu-list');

import {VstInput} from 'vstui';

// Renders the Forgot/Reset Password Containers
class ForgotContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      passwordConfirmation: "", password: "",
      forgotForm: true,
      emailSent: false,
      linkExpired: false,
      passwordReset: false,
      accountExists: false
    };

    // Bind callback methods
    this._onEmailChange = this._onEmailChange.bind(this);
    this._onPasswordChange = this._onPasswordChange.bind(this);
    this._confirmPasswordChange = this._confirmPasswordChange.bind(this);
    this._validatePassword = this._validatePassword.bind(this);
    this._validatePasswordConfirmation = this._validatePasswordConfirmation.bind(this);
    this._checkEmailInput = this._checkEmailInput.bind(this);
    this._dismissFloaterError = this._dismissFloaterError.bind(this);
    this._forgotReset = this._forgotReset.bind(this);
    this._clickCreateAccount = this._clickCreateAccount.bind(this);
    this._resendForgotUrl = this._resendForgotUrl.bind(this);
    this._forgotSignIn = this._forgotSignIn.bind(this);
    this._updateForgotPassword = this._updateForgotPassword.bind(this);

    this.pwdInputRef = React.createRef();
    this.pwdConfirmInputRef = React.createRef();
  }

  componentDidMount(){
    Fraction.Router.setRoute("user/forgot", true);
  }

  componentDidUpdate(){
    // TODO :: Maybe we can bring this up a level?
    Fraction.Helpers.bindLinks();
  }

  _onEmailChange(e){
    this._dismissFloaterError();
    this.setState({email: e.currentTarget.value});
  }

  _onPasswordChange(e){
    this._dismissFloaterError();
    this.setState({password: e.currentTarget.value});
  }

  _confirmPasswordChange(e){
    this._dismissFloaterError();
    this.setState({passwordConfirmation: e.currentTarget.value});
  }

  _validatePassword(e){
    var pwdInput = this.pwdInputRef.current;
    if (!Fraction.Helpers.Users.isValidPassword(this.state.password) && this.state.password.length >= 0){
      this.setState({pwdInputFailure: i18n.t('registration.valid-password')});
      return false;
    }
    this.setState({pwdInputFailure: false});
    return true;
  }

  _validatePasswordConfirmation(e){
    var pwdConfirmationInput = this.pwdConfirmInputRef.current;
    var pwdInput = this.pwdInputRef.current;
    if (this._validatePassword(e) && this.state.passwordConfirmation!==this.state.password){
      if (this.state.passwordConfirmation.length>0){
        this.setState({pwdConfirmationInputFailure: i18n.t('registration.pwd-no-match')});
      }
      return false;
    }
    this.setState({pwdConfirmationInputFailure: false});
    return true;
  }

  _checkEmailInput(e, suppressError){
    var email = $("#email-field").val();
    if (!this.props.isValidEmail(email)){
      this.setState({emailInvalid: i18n.t('signin.invalid-email')});
      e.preventDefault();
      return false;
    }
    this.setState({emailInvalid: false});
    return true;
  }

  _dismissFloaterError(e, suppressError){
    this.setState({emailInvalid: false, floaters: [], pwdConfirmationInputFailure: false, pwdInputFailure: false});
    return true;
  }

  _forgotReset(e, suppressError) {
    e.preventDefault();
    if ((!this.state.nextDisabled || this.state.emailSent) && this._checkEmailInput(e)){
      var forgotUrl = document.location.protocol + '//' + document.location.hostname + (document.location.port ? (':' + document.location.port) : '') + '/#/user/forgot';
      this.setState({nextDisabled: true, resendDisabled: this.state.emailSent});
      Jigsaw.forgotPassword({
        email: this.state.email,
        domain: 'vitalsource.com', // you should extract this from the brand
        updateUrl: forgotUrl }, (response) => {
          if (response.isSuccess()){
            //email sent to user container appears
            this.setState({emailSent: true, nextDisabled: true, accountExists: false});
          } else {
            //account doesnt exist container appears
            this.setState({emailSent: false, nextDisabled: false, accountExists: true});
          }
          return true;
      });
      Fraction.Reporter.gaEvent("forgot-password/send-email");
    }
  }

  _clickCreateAccount(){
    Fraction.Router.setRoute("/user/registration");
  }

  _resendForgotUrl(){
    Fraction.Router.setRoute("/user/forgot");
    Fraction.Reporter.gaEvent("forgot-password/resend");
  }

  _forgotSignIn(){
    Fraction.Router.setRoute("/user/signin");
  }

  _updateForgotPassword(e) {
    e.preventDefault();
    if (this._validatePassword(e) && this._validatePasswordConfirmation(e)){
      (function(container){
        var emailToken = container.props.forgotURLToken;
        Jigsaw.updateForgottenPassword({
          token: emailToken,
          password: container.state.password }, function(response){
            if (response.code === 200 && container.state.password === container.state.passwordConfirmation) {
              /*Fraction.Router.setRoute("/");*/
              container.setState({passwordReset: true, forgotForm: false});
            } else if (container.state.password !== container.state.passwordConfirmation){

            } else {
              //password link expired container appears
              container.setState({linkExpired: true, forgotForm: false});
            }
        });
        Fraction.Reporter.gaEvent("forgot-password/reset-password");
      })(this);
    } else {
      return false;
    }
  }

  render(){
    var redirect = document.location.protocol+"//"+document.location.host;
    var failure = document.location.protocol+"//"+document.location.host+"/#/user/signin/failure";
    if (Fraction.redirectAfterSignIn){
      redirect+="/#/"+Fraction.Helpers.redirectUrl();
    }

    var style = {};
    var loginFailure = this.props.status==="failure" || this.state.status==="failure";

    var forgotPasswordForm;
    if (this.props.forgotURLToken){
      forgotPasswordForm = (
        <span>
          <div style={style}>
            <h1 className="large">
              {this.state.linkExpired ?
                window.toHTML(i18n.t('forgot-password.forgot-password-expired-heading')) :
                window.toHTML(i18n.t('forgot-password.forgot-password-heading'))
              }
            </h1>
            <h1 className="small">
              {this.state.linkExpired ?
                window.toHTML(i18n.t('forgot-password.forgot-password-expired-heading')) :
                window.toHTML(i18n.t('forgot-password.forgot-password-heading'))
              }
            </h1>
          </div>
          {this.state.forgotForm &&
            <form style={style} onSubmit={this._updateForgotPassword} id="update-forgot-form" method="get" noValidate>
              <VstInput required
                        id="password-input"
                        label={i18n.t('base.password')}
                        failure={this.state.pwdInputFailure}
                        ref={this.pwdInputRef}
                        options="large"
                        type="password"
                        data-key="password"
                        onBlur={this._validatePassword}
                        placeholder={i18n.t('forgot-password.new-password')}
                        onChange={this._onPasswordChange}
                        value={this.state.password} />
              <VstInput required
                        id="password-confirm-input"
                        label={i18n.t('base.confirm-password')}
                        failure={this.state.pwdConfirmationInputFailure}
                        ref={this.pwdConfirmInputRef}
                        options="large"
                        type="password"
                        placeholder={i18n.t('base.confirm-password')}
                        data-key="passwordConfirmation"
                        onBlur={this._validatePasswordConfirmation}
                        onChange={this._confirmPasswordChange}
                        value={this.state.passwordConfirmation} />
              <VstInput type="submit"
                        value={i18n.t('base.submit')}
                        options="btn-44 block"
                        disabled={this.state.nextDisabled ? "disabled" : undefined} />
            </form>
          }
        </span>
      );
    } else {
      forgotPasswordForm = (
        <span>
          <h1 className="large">
            {window.toHTML(i18n.t('forgot-password.forgot-password-heading'))}
          </h1>
          <h1 className="small">
            {window.toHTML(i18n.t('forgot-password.forgot-password-heading'))}
          </h1>
          {this.state.forgotForm &&
            <form onSubmit={this._forgotReset} id="forgot-form" method="get" noValidate>
              <VstInput required
                        label={i18n.t('base.email')}
                        id="email-field"
                        type="email"
                        options="large"
                        failure={this.state.emailInvalid}
                        onBlur={this._checkEmailInput}
                        value={this.state.email}
                        onChange={this._onEmailChange}
                        placeholder={i18n.t('base.email')} />
              <VstInput type="submit"
                        value={i18n.t('base.submit')}
                        options="btn-44 block"
                        disabled={this.state.nextDisabled ? "disabled" : undefined} />
            </form>
          }
        </span>
      );
    }

    return (
      <div>
        <div onScroll={this.props.redraw}>
          { Fraction.Helpers.modalToShow }

          <div className="account">

            {this.props.renderAccountGraphic("forgot")}

            <div className="account-content forgot">

              <div className="step check-email">

                {forgotPasswordForm}

                {this.state.emailSent &&
                  <div className="step email-sent">
                    <h2>{i18n.t('forgot-password.forgot-sent-heading')}</h2>
                    <p>{i18n.t('forgot-password.forgot-sent-text')}</p>
                    <form id="forgot-create-account" method="get" onSubmit={this._forgotReset}>
                      <VstInput disabled={this.state.resendDisabled} type="submit" options="btn-28" className="create-account" value={i18n.t('forgot-password.resend')} />
                    </form>
                  </div>
                }

                {this.state.accountExists &&
                  <div className="step account-exist">
                    <h2>{i18n.t('forgot-password.doesnt-exist-heading')}</h2>
                    <p>{i18n.t('forgot-password.try-again-text')}</p>
                    <form id="forgot-create-account" method="get" onSubmit={this._clickCreateAccount}>
                      <VstInput type="submit" options="btn-28" className="create-account" value={i18n.t('forgot-password.create-account')} />
                    </form>
                  </div>
                }

                {this.state.linkExpired &&
                  <div className="step password-link-expired">
                    <p>{i18n.t('forgot-password.link-expired-text')}</p>
                    <form id="forgot-create-account" method="get" onSubmit={this._resendForgotUrl}>
                      <input type="submit" options="btn-28" className="create-account reset" value={i18n.t('forgot-password.reset-button')} />
                    </form>
                  </div>
                }

                {this.state.passwordReset &&
                  <div className="step password-reset">
                    <h2>{i18n.t('forgot-password.password-reset')}</h2>
                    <p>{i18n.t('forgot-password.password-reset-text')}</p>
                    <form id="forgot-create-account" method="get" onSubmit={this._forgotSignIn}>
                      <VstInput type="submit" options="btn-28" className="create-account reset" value={i18n.t('signin.signin-button')} />
                    </form>
                  </div>
                }

                <div className="subheading">
                  {window.toHTML(i18n.t('forgot-password.remember-password-signin', {url: "/#/user/signin"}))}
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }

}

module.exports = ForgotContainer;
